import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import { getTranslate } from 'legacy-src/utilities/i18n'
import React from 'react'

import Icon from '@/legacy-src/components/icons/Icon'
import { TZ } from '@/legacy-src/constants/date.constants'

dayjs.extend(timezone)
dayjs.extend(utc)

const CalendarTimezoneInfo: React.FC = () => {
  const { t } = getTranslate()

  const userTimezone = dayjs().tz(dayjs.tz.guess()).utcOffset() / 60

  if (dayjs().tz(TZ).utcOffset() / 60 !== userTimezone) {
    return (
      <div className="mb-5 flex items-center gap-2 rounded-xl bg-yellow-500 p-4 text-sm text-secondary">
        <Icon icon="info" />{' '}
        {t('calendar.toolbarInfo.timezone', {
          timezone: userTimezone > 0 ? `(GMT+${userTimezone} h)` : `(GMT${userTimezone} h)`,
        })}
      </div>
    )
  }
  return null
}

export default CalendarTimezoneInfo
